import React from "react";
import VideoPlayer from "lib/common/components/VideoPlayer";
import {
    buildFileUrl,
} from "data/selectors/fileUploads";

// TODO: add proptypes
export default class RFPI extends React.Component {
    buildFile(f) {
        return {
            ...f,
            id: f.id,
            filename: f.filename,
            _status: Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE,
            progress: f._progress || 0,
            filesize: f.size,
            model: f
        };
    }

    buildVideoProps(file) {
        if (file) {
            const sources = [{
                src: buildFileUrl(this.buildFile(file)),
                type: file.contentType,
            }];

            return {
                controls: true,
                loop: true,
                height: 800,
                width: 800,
                sources: sources,
                seekSize: 1/30,
            };
        }

        return {};
    }

    render() {
        const {
            imageFile,
            selectedComparisons,
            dropdown,
            selector,
            mode
        } = this.props;

        const videoProps = this.buildVideoProps(imageFile);


        let body;
        if (selectedComparisons) {
            // TODO: clean this up
            const comparisonVideoProps = [
                this.buildVideoProps(selectedComparisons[0]),
                this.buildVideoProps(selectedComparisons[1])
            ];
            body = (
                <React.Fragment>
                    <VideoPlayer {...comparisonVideoProps[0]} />
                    <VideoPlayer {...comparisonVideoProps[1]} />
                </React.Fragment>
            );
        } else {
            body = <VideoPlayer {...videoProps} />;
        }

        switch(mode) {
            case "comparison":
                return (
                    <React.Fragment>
                        {selector}
                        {dropdown}
                        <div className="video-container">
                            {body}
                        </div>
                    </React.Fragment>
                );
            case "individual":
            default:
                return (
                    <React.Fragment>
                        {selector}
                        <div className="video-container">
                            {body}
                        </div>
                    </React.Fragment>
                );
        }
    }
}



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/FileField/RFPI.js